<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">คำนำหน้าชื่อ</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!formShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::employee_prefix:create')
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddPrefixForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มคำนำหน้าชื่อ
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="prefixs"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <PrefixForm
      :formShow="formShow"
      :formAction="formAction"
      :prefix="prefix"
      :prefixInit="prefixInit"
      @isPrefixDataChange="handlePrefixFormDataChange"
      @formActionCompleted="handleFormActionCompleted"
      @onReset="handlePrefixFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="formShow && formAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import PrefixForm from '@/views/prefix/PrefixForm.vue'

export default {
  components: {
    PrefixForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        { text: 'คำนำหน้าชื่อ', value: 'title_th' },
        { text: 'คำนำหน้าชื่อ (อังกฤษ)', value: 'title_en' },
        { text: 'รหัสคำนำหน้าชื่อ', value: 'company_prefix_code' },
      ],
      formShow: false,
      formAction: '',
      prefix: {},
      prefixInit: {},
      isPrefixDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    prefixs() {
      return this.$store.state.prefix.prefixs
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'คำนำหน้าชื่อ',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchPrefixs: 'prefix/fetchPrefixs',
    }),
    classRowSelected(row) {
      if (this.prefix.company_prefix_uuid === row.company_prefix_uuid) {
        return 'row-selected'
      }
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::employee_prefix:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.prefix.company_prefix_uuid === row.company_prefix_uuid) {
        this.formShow = false
        this.formAction = ''
        this.prefix = {}
        this.prefixInit = {}
      } else {
        this.formShow = true
        this.formAction = 'edit'
        this.prefix = { ...row }
        this.prefixInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isPrefixDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddPrefixForm() {
      this.formShow = true
      this.formAction = 'add'
      this.prefix = {}
      this.prefixInit = {}
    },
    handlePrefixFormDataChange(value) {
      this.isPrefixDataChange = value
    },
    handlePrefixFormReset(formAction) {
      if (formAction === 'edit') this.prefix = { ...this.prefixInit }
    },
    handleFormActionCompleted(formAction) {
      this.prefix = {}
      this.prefixInit = {}
      this.formShow = false
      this.formAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
      }
      const prefixs = this.fetchPrefixs(payload)

      Promise.all([prefixs])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isPrefixDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
